import "./ConfirmDangerModal.css";

/**
 * ConfirmDangerModal — modal genérico de confirmación para acciones
 * destructivas (ej. desvincular dispositivo).
 *
 * Props:
 *  - titulo: string          (ej. "¿Desvincular este dispositivo?")
 *  - body:   string | JSX    (descripción del efecto)
 *  - confirmLabel?: string   (default "Confirmar")
 *  - cancelLabel?: string    (default "Cancelar")
 *  - onConfirm: () => void
 *  - dismiss: () => void
 */
const ConfirmDangerModal = ({
  titulo = "¿Estás seguro?",
  body,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  onConfirm,
  dismiss,
}) => {
  return (
    <div className="ptur-confirmdanger-container">
      <div className="ptur-confirmdanger-header c-white">
        <span className="rb18m">{titulo}</span>
      </div>
      <div className="ptur-confirmdanger-body">
        {body && <span>{body}</span>}
        <div className="ptur-confirmdanger-botones">
          <div
            className="btn ptur-confirmdanger-btnPrimary c-white rb18m pointer"
            onClick={onConfirm}
          >
            {confirmLabel}
          </div>
          <div
            className="btn ptur-confirmdanger-btnSecondary c-white rb18m pointer"
            onClick={dismiss}
          >
            {cancelLabel}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDangerModal;
